import * as React from "react";

import "./template-list.scss";

import {cs}              from "@Common/react/chain-services";
import {keyed}           from "@Common/react/keyed";
import {scnv}            from "@Common/react/state-change-nested-value";
import {sort}            from "@Common/utils/collections";
import {toJsDate}        from "@Common/utils/date-object";
import {parseDateFormat} from "@Common/utils/date/parse-date-format";
import {chain}           from "@Common/utils/fs";

import {ScTemplateCard} from "./template-card/sc-template-card";

export const TemplateList = ({program, editions, getStyleTemplate}) => cs(
    ["cardRenderer", (_, next) => ScTemplateCard({next})],
    ({cardRenderer}) => (
        <div {...{
            className: "template-list-66s",

            "xd-qa-type": "card",
            "xd-qa-name": "Personal greeting",
        }}>
            <div {...{
                className: "title",
                "xd-qa-type": "label",
                "xd-qa-name": "Personal greeting",
            }}>
                Add a personal greeting to include on each piece:
            </div>

            <div className="box">
                {chain(
                    editions.value,
                    (_) => _?.map((ue) => ({ue, pe: program.programPreferences.editions.find((e1) => e1.editionId === ue.editionId)})),
                    (_) => sort(_, ({pe}) => chain(
                        pe,
                        (pe) => pe && df2.parseDate(pe.orderReviewDeadline),
                        (date) => !date ? null : toJsDate(date).getTime(),
                    )),
                    (_) => _?.map(({ue, pe}) => cs(
                        keyed(ue.editionId),
                        ({}, next) => (
                            <div className="cell">
                                {next()}
                            </div>
                        ),
                        ["template", ({}, next) => next(getStyleTemplate(pe.templateId))],
                        ({template}) => (
                            cardRenderer.renderCard({
                                label: pe.name,
                                template,
                                commentChanging: {
                                    onChange: (newComment) => scnv(editions, [editions.value.indexOf(ue), "comment"], () => newComment),
                                    onReset: () => scnv(editions, [editions.value.indexOf(ue), "comment"], () => null),
                                },
                                maxCommentLength: 70,
                                // comment: ue.comment ?? pe.comment,
                                comment: ue.comment,
                                defaultComment: pe.comment,
                                description: pe.description,
                            })
                        )
                    )),
                )}
            </div>
        </div>
    ),
);

const df2 = parseDateFormat("yyyy-mm-dd");

